export default __webpack_public_path__ + "static/handsworking-0ecea1b2f9b760bcaee513868bc13ef5.png";